import { EScheduleFrequency, EWeekDays } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import { serviceNameViaPoint } from '@/components/services/report-manager/recurrent/utils'
import { filterBy } from '@/components/services/report-manager/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [
    proxy({ type: 'object' }),
    filterBy
  ],

  props: {
    isNew: Boolean,
    loading: Boolean,
    paddless: Boolean
  },

  computed: {
    /**
     * Проверяет базовую валидность формы и согласованность обязательных полей filterBy.
     *
     * @returns {boolean}
     */
    validation() {
      return Boolean(this.proxy.name && this.proxy.type) && !this.filterByRequiredFieldsIsEmpty
    },

    frequencies() {
      return Object.values(EScheduleFrequency).map(value => {
        return {
          value,
          title: this.getTranslate(`${serviceNameViaPoint}.frequencies.${value}`)
        }
      })
    },
    /**
     * Собирает человекочитаемое описание частоты запуска.
     * Для еженедельного режима намеренно подставляется воскресенье,
     * чтобы карточка не теряла смысл при пустом дне недели.
     *
     * @returns {string | undefined}
     */
    frequencyDescription() {
      const frequencyText = this.getTranslate(`${serviceNameViaPoint}.frequencies.${this.proxy.scheduleFrequency}`)
      const specificWeekDay = this.proxy.specificWeekDay
      let weekDayText = this.getTranslate(`${serviceNameViaPoint}.weekDays.${EWeekDays.SUNDAY}`)

      if (specificWeekDay) {
        weekDayText = this.getTranslate(`${serviceNameViaPoint}.weekDays.${this.proxy.specificWeekDay}`)
      }

      switch (this.proxy.scheduleFrequency) {
        case EScheduleFrequency.EVERY_MONTH: return frequencyText
        case EScheduleFrequency.EVERY_WEEK: return `${frequencyText} - ${weekDayText}`
      }
    },

    weekDays() {
      return Object.values(EWeekDays).map(value => {
        return {
          value,
          title: this.getTranslate(`${serviceNameViaPoint}.weekDays.${value}`)
        }
      })
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}

